import { styled } from '@/lib/utils'

export const PageGrid = styled('div')('grid gap-4 pb-25')

export const DeploymentPageHeader = styled('div')('flex items-center gap-4')

export const DeploymentDetailsGrid = styled('div')(
  'space-y-6 md:space-y-0 md:grid gap-x-4 gap-y-6 md:max-w-[5fr] items-baseline'
)
